<template>
  <div class="cta">
    <vb-button
      class="cta__btn"
      :vb_options="{
        text: 'Continua',
        variant: 'info',
        icon_disabled: 'lock_v2',
        block: true,
        disabled: cta_status.disabled || !get_availability(solution.pricing.live_price_no_tax).can_go_to_checkout
      }"
      @click="scroll_to_bottom()"
    />
    <div v-if="cta_status.disabled" :class="'cta__text text-' + cta_status.variant">
      <vb-icon class="cta__text-icon mr-1" :name="'info'" :color="sass(cta_status.variant)" :size="14" />
      <p class="mb-0" v-html="cta_status.label"></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'resume-cta',

  inject: ['cta_status_checker', 'get_scroll_target'],

  components: {
  },

  props: {
    solution: Object
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      // stato globale
      occupancy: state => state.occupancy,
    }),

    // Ritorna un oggetto con nome prodotto scelto e quantità
    product_selected() {
      const result = {}

      for (const key in this.solution.rooms) {
        const products = this.solution.rooms[key].products
        for (const key in products) {
          result[key] = products[key].price_selected.qty
        }
      }
      return result
    },

    // Gestisce i copy e lo stato della cta
    cta_status(){
      const rooms = Object.values(this.product_selected).reduce((total, value) => total + value, 0),
          occupancy = this.occupancy.length,
          rooms_not_selected = rooms === 0,
          rooms_more_occupancy = rooms > occupancy,
          rooms_less_occupancy = rooms < occupancy

      let label = '',
          variant = ''

      if (rooms_not_selected) {
        label = `Scegli una ${this.get_config('guiSettings.maxRooms') > 1 ? ' o più camere ' : ' camera '}
                <span class="d-block mt-1 ml-n3 text--sm">
                  Il numero di camere deve essere uguale al numero di camere che hai cercato nel motore di ricerca.
                </span>`
        variant = 'dark'
      } else if (rooms_more_occupancy) {
        label = `Hai selezionato più camere del necessario
                <span class="d-block mt-1 ml-n3 text--sm">
                  Il numero di camere ricercate e il numero di quelle selezionate devono essere uguali. Probabilmente
                  ne hai selezionate troppe. Cambia la selezione o fai una nuova ricerca.
                </span>`
        variant = 'danger'
      } else if (rooms_less_occupancy) {
        label = `Seleziona altre camere
                <span class="d-block mt-1 ml-n3 text--sm">
                  Hai selezionato meno camere di quelle che hai cercato. Seleziona il numero giusto. Se hai cambiato
                  idea, fai una nuova ricerca.
                </span>`
        variant = 'primary'
      }

      const result = {
        disabled: rooms !== occupancy,
        label,
        variant
      }

      this.cta_status_checker(result)

      return result
    }

  },

  methods: {

    scroll_to_bottom() {
      const target = this.get_scroll_target()
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  },
}
</script>

<style lang="scss" scoped>

  .cta {

    &__btn {
      width: 100%;

      @include media-breakpoint-up(sm){
        width: 40%;
        float: right;
      }

      @include media-breakpoint-up(xl){
        width: 100%;
        float: none;
      }
    }

    &__text {
      margin-bottom: 0;
      margin-top: 20px;
      display: flex;
      align-items: flex-start;
      line-height: 18px;
      justify-content: center;

      @include media-breakpoint-up(sm){
        margin-top: 0;
      }

      @include media-breakpoint-up(xl){
        margin-top: $grid-gutter-width;
        margin-bottom: $grid-gutter-width/2;
      }

      &-icon {
        margin-top: 2px;
      }
    }
  }

</style>